import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import { uniqBy } from "lodash";
import * as UTIL from '../../util';
var Creators = Actions.Creators;
var pageChangeRetail = Creators.pageChange;
var termChangeRetail = Creators.termChange;
var facetsChangeRetail = Creators.facetsChange;
var categoriesChangeRetail = Creators.categoriesChange;
var requestRetail = Creators.request;
var receiveRetail = Creators.response;
var requestCategories = Creators.requestCategories;
var receiveCategories = Creators.receiveCategories;
var pageSizeRetail = Creators.pageSizeChange;
var dataSourceChangeRetail = Creators.dataSourceChange;
var sortByChangeRetail = Creators.sortByChange;
var addToRecentlyViewedRetail = Creators.addToRecentlyViewed;
var setCurrentCategoryRetail = Creators.setCurrentCategory;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

var handleFacets = function handleFacets(selected) {
  var facets = selected.map(function (facet) {
    return facet[1].length ? "".concat(facet[0], "=").concat(btoa(facet[1].join())) : "";
  }).filter(Boolean).join(",");
  return facets ? "f=".concat(facets, "&") : "";
};

var getCategoriesRetail = function getCategoriesRetail() {
  return function (dispatch) {
    dispatch(requestCategories());
    return UTIL.apiUtil.fetchGet(UTIL.apiUtil.API.retail.getCategories).then(function (json) {
      json.push({
        Description: "Gift Card",
        DisplayName: "Gift Card",
        isActive: "false",
        CategoryContentPagePath: "/shop/gift-cards/plastic-gift-cards",
        Categories: [],
        CategoryContentPageName: null,
        HideSizeChart: false,
        Image: {
          Src: "",
          Alt: null
        },
        Name: "CB_Retail_Store-22",
        Products: [],
        SitecoreId: "{60B0CDA3-FA7B-71D9-7089-C2710947B72A}",
        Slug: "plastic-gift-cards",
        SortOrder: 0
      });
      dispatch(receiveCategories({
        retailCategories: json
      }));
      return json;
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}; //Saves for facets call, only get on page load


var savedValue = "";
var savedPath = "";

var categoryGet = function categoryGet() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var catArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (savedValue && savedPath == path) {
    return savedValue;
  }

  for (var i = 0; i < catArray.length; i++) {
    var current = catArray[i];

    if (current.CategoryContentPagePath.toLowerCase() === path) {
      savedValue = current.SitecoreId;
      savedPath = path;
      break;
    }

    categoryGet(path, catArray[i].Categories);
  }

  return savedValue;
};

var tries = 0;

function fetchRetail(state, parentctg) {
  return function (dispatch) {
    dispatch(requestRetail());
    var path = window.location.pathname.toLowerCase(); //defaulting to "null" if it doesn't categoryGet

    var ctg = categoryGet(path, parentctg || state.retail.retailCategories) || null;
    dispatch(setCurrentCategoryRetail(ctg));
    var category = "ctg=".concat(ctg, "&");
    var currentCategory = state.retail.currentCategory;
    var currentPage = 'pg=0';

    if (currentCategory !== null && currentCategory !== ctg) {
      currentPage = 'pg=0&';
      dispatch(pageChangeRetail({
        currentPage: 0
      }));
    } else {
      currentPage = typeof state.retail.currentPage === "number" ? "pg=".concat(state.retail.currentPage, "&") : "";
    }

    var facets = "".concat(handleFacets(Object.entries(state.retail.selectedFacets)));
    var order = state.retail.sortOrder ? "sd=".concat(state.retail.sortOrder, "&") : "";
    var sortBy = state.retail.sortBy ? "s=".concat(state.retail.sortBy, "&") : "";
    var params = "".concat(currentPage).concat(category).concat(sortBy).concat(order).concat(facets);
    return UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.retail.getRetail, "?").concat(params)).then(function (json) {
      var pascal = UTIL.toPascal(json);
      var cards = Array.isArray(pascal.Products) ? pascal.Products.map(function (product) {
        return {
          fields: UTIL.mapProductRetail(product)
        };
      }) : [];
      pascal.Cards = cards.filter(Boolean);

      if (Array.isArray(pascal.Facets) && pascal.Facets.length > 0) {
        pascal.Facets = pascal.Facets.map(function (category) {
          var currentFacet = state.retail.selectedFacets[category.Name];
          var results = category.FoundValues.map(function (value) {
            return {
              Name: value.Name,
              Count: value.Count || value.AggregateCount,
              Value: currentFacet ? currentFacet.indexOf(value.Name) !== -1 : false
            };
          });
          var Filtered = results.filter(function (el) {
            return Boolean(el.Count);
          });
          return _objectSpread(_objectSpread({}, category), {}, {
            Values: Filtered,
            FoundValues: Filtered
          });
        });
      } else {
        pascal.Facets = [];
      }

      if (Array.isArray(pascal.SortOptions) && pascal.SortOptions.length > 0) {
        pascal.SortOptions = pascal.SortOptions.map(function (option) {
          return {
            fields: {
              key: {
                value: [option.Name, option.SortDirection, option.IsSelected]
              },
              value: {
                value: option.DisplayName
              }
            }
          };
        });
      } else {
        pascal.SortOptions = [];
      }

      if (pascal.Products.length === 0 && tries <= 2) {
        tries++;
        return dispatch(getCategoriesRetail()).then(function (res) {
          return dispatch(fetchRetail(state, res));
        });
      }

      dispatch(receiveRetail(pascal));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

var pageChange = function pageChange(pageNumber) {
  console.log(pageNumber, "pageNumber");
  return function (dispatch, getState) {
    var state = getState();
    dispatch(pageChangeRetail({
      currentPage: pageNumber
    }));
    return dispatch(fetchRetail(getState()));
  };
};

var termChange = function termChange(clearFacets) {
  return function (dispatch, getState) {
    if (clearFacets === true) {
      dispatch(facetsChangeRetail({
        selectedFacets: []
      }));
    }

    return dispatch(fetchRetail(getState()));
  };
};

var setPageSize = function setPageSize(pageSize) {
  return function (dispatch, getState) {
    var state = getState();
    return dispatch(pageSizeRetail({
      pageSize: pageSize || state.pageSize
    }));
  };
};

function arrayRemove(arr, value) {
  return arr.filter(function (ele) {
    return ele != value;
  });
}

var topicChange = function topicChange(topic, isAdd) {
  return function (dispatch, getState) {
    var state = getState();
    var results;

    if (isAdd) {
      results = [].concat(_toConsumableArray(state.retail.topics), [topic]);
    } else {
      results = arrayRemove(state.retail.topics, topic);
    }

    dispatch(topicsChangeRetail({
      topics: results
    }));
    return dispatch(pageChange(1));
  };
};

var facetChange = function facetChange(facet, isAdd, slug) {
  return function (dispatch, getState) {
    var state = getState();
    var facets = state.retail.selectedFacets || [];
    var currentSelected = facets[slug] || [];

    if (isAdd) {
      facets[slug] = [].concat(_toConsumableArray(currentSelected), [facet]);
    } else {
      facets[slug] = arrayRemove(facets[slug], facet);
    }

    dispatch(facetsChangeRetail({
      selectedFacets: facets
    }));
    return dispatch(fetchRetail(getState()));
  };
};

var categoriesChange = function categoriesChange(category, isAdd) {
  return function (dispatch, getState) {
    var state = getState();
    var results;

    if (isAdd) {
      results = [].concat(_toConsumableArray(state.retail.categories), [category]);
    } else {
      results = arrayRemove(state.retail.categories, category);
    }

    dispatch(categoriesChangeRetail({
      categories: results
    }));
    return dispatch(fetchRetail(getState()));
  };
};

var setDataSource = function setDataSource(dataSource) {
  return function (dispatch) {
    return dispatch(dataSourceChangeRetail({
      dataSource: dataSource
    }));
  };
};

var sortByChange = function sortByChange(sortBy) {
  var parsedArray = sortBy.split(","); // parsedArray order = [Name, Order, Selected]

  return function (dispatch, getState) {
    dispatch(sortByChangeRetail({
      sortBy: parsedArray[0],
      sortOrder: parsedArray[1]
    }));
    return dispatch(fetchRetail(getState()));
  };
};

var getCategories = function getCategories() {
  return function (dispatch, getState) {
    var _state$retail;

    var state = getState();
    var categories = ((_state$retail = state.retail) === null || _state$retail === void 0 ? void 0 : _state$retail.retailCategories) || [];

    if (!categories.length) {
      dispatch(getCategoriesRetail());
    }
  };
};

var addToRecentlyViewed = function addToRecentlyViewed(newViewedObj) {
  return function (dispatch, getState) {
    var state = getState();
    console.log(state.retail.recentlyViewed, "OLDARRAY");
    var recentlyViewed = state.retail.recentlyViewed || [];
    var newArray = [newViewedObj].concat(_toConsumableArray(recentlyViewed));
    var uniqueArray = uniqBy(newArray, 'href');
    uniqueArray.length = Math.min(uniqueArray.length, 12);
    dispatch(addToRecentlyViewedRetail(uniqueArray));
  };
};

export default {
  fetchRetail: fetchRetail,
  receiveError: receiveError,
  receiveRetail: receiveRetail,
  pageChange: pageChange,
  termChange: termChange,
  topicChange: topicChange,
  categoriesChange: categoriesChange,
  setPageSize: setPageSize,
  setDataSource: setDataSource,
  sortByChange: sortByChange,
  getCategories: getCategories,
  facetChange: facetChange,
  addToRecentlyViewed: addToRecentlyViewed
};